import { withChartLayout } from 'components/common';
import SymptomAnalysis from 'components/features/chart/system-assessment/symptom-analysis/SymptomAnalysis';
import { SectionTitle } from 'components/features/chart/system-assessment/symptom-analysis/constants';

const SymptomAnalysisPage = withChartLayout(SectionTitle.SYMPTOM_ANALYSIS)(SymptomAnalysis);
export default SymptomAnalysisPage;
